/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import createCache from "@emotion/cache";
import { useServerInsertedHTML } from "next/navigation";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { useMode, ColorModeContext } from "./theme";
import { Box } from "__barrel_optimize__?names=Box!=!@mui/material";
// This implementation is from emotion-js
// https://github.com/emotion-js/emotion/issues/2928#issuecomment-1319747902
// https://mui.com/material-ui/guides/next-js-app-router/
export default function ThemeRegistry(props) {
    const { options, children } = props;
    const [theme, colorMode] = useMode();
    const [{ cache, flush }] = useState(()=>{
        const cache = createCache(options);
        cache.compat = true;
        const prevInsert = cache.insert;
        let inserted = [];
        cache.insert = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            const serialized = args[1];
            if (cache.inserted[serialized.name] === undefined) {
                inserted.push(serialized.name);
            }
            return prevInsert(...args);
        };
        const flush = ()=>{
            const prevInserted = inserted;
            inserted = [];
            return prevInserted;
        };
        return {
            cache,
            flush
        };
    });
    useServerInsertedHTML(()=>{
        const names = flush();
        if (names.length === 0) {
            return null;
        }
        let styles = "";
        for (const name of names){
            styles += cache.inserted[name];
        }
        return /*#__PURE__*/ _jsx("style", {
            "data-emotion": "".concat(cache.key, " ").concat(names.join(" ")),
            dangerouslySetInnerHTML: {
                __html: styles
            }
        }, cache.key);
    });
    return /*#__PURE__*/ _jsx(ColorModeContext.Provider, {
        value: colorMode,
        children: /*#__PURE__*/ _jsxs(ThemeProvider, {
            theme: theme,
            children: [
                /*#__PURE__*/ _jsx(CssBaseline, {}),
                /*#__PURE__*/ _jsx(Box, {
                    minHeight: "100vh",
                    height: "100%",
                    className: "app",
                    sx: {
                        backgroundColor: "#F3F5FD"
                    },
                    children: children
                })
            ]
        })
    });
}
